import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { ServiceThreadSpinner, CorrectiveActionsGrid } from '.';
import { api, helpers, constants } from '../utils';

export default function CustomerCorrectiveActions(props) {
   const [correctiveActions, setCorrectiveActions] = useState(null);
   const [customerId, setCustomerId] = useState(props.customerId);
   const [loaded, setLoaded] = useState(false);
   const [page, setPage] = useState(1)
   const [sortDirection, setSortDirection] = useState("desc");
   const [sortField, setSortField] = useState("createdDate");
   const [totalPages, setTotalPages] = useState(null)

   useEffect(() => {
      if (customerId !== props.customerId) {
         setCustomerId(props.customerId);
         setLoaded(false);
      }

      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId]);

   function createPayload() {
      return {
         CustomerId: customerId,
         SortField: sortField,
         SortDirection: sortDirection,
         ActionType: constants.CORRECTIVE_ACTION_TYPES.CorrectiveAction,
         ActionStatus: 0,      // ???
         ProblemType: 0,       // ???
         IncludeInternal: false,
         PageNumber: page,
         PageSize: 10,
         CalledFromSalesDashboard: false
      }
   }

   function exportXLSX() {
      api
         .postGetBlob("Customer/ExportCorrectiveActionsXLSX", createPayload())
         .then((response) => {
            if (response && response.data) {
               const XLSX_FILENAME = `${customerId}_CorrectiveActions.xlsx`;
               helpers.downloadExport(response.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx);
            }
            else {
               toast.error(response.message || "Error Downloading Report.");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post("Quality/GetPaginatedCorrectiveActions", createPayload())
         .then((response) => {
            if (response.data.success) {
               setCorrectiveActions(response.data.correctiveActions.items);
               setTotalPages(_.ceil(response.data.correctiveActions.totalCount / 10));
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));
   }

   function onPageChange(page) {
      setPage(page);
      setLoaded(false);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc")
      } else {
         setSortDirection(direction);
      }
      onPageChange(1);
   }

   return (
      <>
         <div>
            <span className="h2 me-2">Corrective Action History</span> <span className="text-muted">Customer #{customerId}</span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {correctiveActions && correctiveActions.length
               ? <CorrectiveActionsGrid
                  data={correctiveActions}
                  sortCallback={onSortChange}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  pagerCallback={onPageChange}
                  pageNumber={page}
                  totalPages={totalPages}
                  exportXlsxCallback={exportXLSX}
               />
               : <span className="h5">No Corrective Actions found</span>}
         </ServiceThreadSpinner>
      </>
   )
}